import { ViewProcessor } from "./index";
import { View } from "../index";

export default class FormViewProcessor extends ViewProcessor
{
    public afterRender(view: View): PromiseLike<void>
    {
        const forms = view.element.querySelectorAll('form');
        
        for(let form of forms)
        {
            form.addEventListener('submit', e =>
            {
                e.preventDefault();
            
                view.formSubmitted(form);
            });
        }

        return super.afterRender(view);
    }
}